import { Component } from '@angular/core';

@Component({
  selector: 'app-header-deslogado',
  templateUrl: './header-top.component.html',
  styleUrls: ['./header-top.component.css']
})
export class HeaderTopComponent {

  isMobileHeader: Boolean = false;

  constructor(
  ) {

  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/header-top/header-top.component.ts